/**
 * Returns DOMParser object
 *
 * @param {string} string
 * @returns {Document}
 */
export default function stringToXml(string) {
    let str = string && typeof string === 'string'
        ? string.trim()
        : '';
    if (!str) {
        throw new Error(`Invalid xml string input: ${String(string).substr(0, 15)}...`);
    }
    str = str.replace(/\u23CE/g, '');
    try {
        return (new window.DOMParser()).parseFromString(str, 'text/xml');
    } catch (e) {
        throw new Error(e);
    }
}
